<template>
    <div
        role="group"
        aria-label="File view"
        class="flex items-center gap-x-1"
        data-test="file-view-toggle"
    >
        <!-- The Leads view switch, with the names and pressed state its icon buttons lack. -->
        <MuvalTippy
            v-for="option in OPTIONS"
            :key="option.value"
            triggers="mouseenter"
        >
            <button
                type="button"
                class="h-input focus-visible:ring-focus grid w-9.5 place-items-center rounded-md transition focus:outline-hidden focus-visible:ring-2"
                :class="
                    view === option.value ?
                        'bg-muval-brand/10 text-muval-brand'
                    :   'text-muval-gray-3 hover:text-muval-gray-2'
                "
                :aria-label="option.label"
                :aria-pressed="view === option.value"
                :data-test="`file-view-${option.value}`"
                @click="view = option.value"
            >
                <SvgIcon
                    :name="option.icon"
                    :class="option.iconClass"
                />
            </button>
            <template #content>
                <span class="text-sm">{{ option.label }}</span>
            </template>
        </MuvalTippy>
    </div>
</template>

<script setup lang="ts">
import MuvalTippy from '@components/MuvalTippy.vue';
import SvgIcon from '@components/utilities/SvgIcon.vue';
import type { FileListView } from '@composables/useFileListView';

/** Switches a file list between its rows and its thumbnail grid. */

const view = defineModel<FileListView>({ required: true });

// The photo glyph is drawn edge to edge on its viewBox, so it is a step smaller to sit level with the padded list icon.
const OPTIONS: { value: FileListView; label: string; icon: string; iconClass: string }[] = [
    { value: 'list', label: 'List view', icon: 'system-list-view', iconClass: 'size-6' },
    { value: 'thumbnail', label: 'Thumbnail view', icon: 'system-photo', iconClass: 'size-4.5' },
];
</script>
